// extracted by mini-css-extract-plugin
export var connectionButton = "_9i-1";
export var rightPanel = "_9i-3";
export var stepDescription = "_9i-2";
export var stepIcon = "_9i-0";